module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "calendars-hours-table"
  }, [_vm._m(0), _vm._v(" "), _c('tr', {
    staticClass: "calendar-item calendar-item--subject"
  }, [_vm._m(1), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "do-input",
    attrs: {
      "type": "number",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.subjectHoursInput
    },
    on: {
      "focus": _vm.selectAll,
      "input": function($event) {
        _vm.subjectHoursInput = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSavingSubjectHours,
      'do-bttn--submit--disabled': !_vm.isSubjectHoursChanged
    },
    attrs: {
      "disabled": _vm.isSavingSubjectHours || !_vm.isSubjectHoursChanged
    },
    on: {
      "click": _vm.submitSubjectHours
    }
  }, [_vm._v("\n          Gem\n        ")])])]), _vm._v(" "), _vm._l((_vm.sortedRows), function(row) {
    return _c('tr', {
      key: row.calendar_id,
      staticClass: "calendar-item"
    }, [_c('td', [_vm._v("\n        " + _vm._s(_vm.calendarName(row.calendar_id)) + "\n        "), (_vm.differsFromSubject(row)) ? _c('div', {
      staticClass: "do-pill do-pill--yellow calendars-hours-pill"
    }, [_vm._v("afviger fra brikken (" + _vm._s(_vm.subjectDefaultHours()) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.isEditable(row.calendar_id)) ? _c('td', [_c('input', {
      staticClass: "do-input",
      attrs: {
        "type": "number",
        "step": "0.1",
        "placeholder": _vm.fallbackPlaceholder(row)
      },
      domProps: {
        "value": row.hours
      },
      on: {
        "focus": _vm.selectAll,
        "input": function($event) {
          return _vm.onInput(row.calendar_id, $event.target.value)
        }
      }
    })]) : _c('td', [_c('span', [_vm._v("\n          " + _vm._s(_vm.displayHours(row)) + "\n          "), _c('div', {
      staticClass: "do-pill do-pill--yellow calendars-hours-pill"
    }, [_vm._v(_vm._s(_vm.displayHoursSource(row)))])])]), _vm._v(" "), _c('td', [(_vm.isEditable(row.calendar_id)) ? _c('button', {
      staticClass: "do-bttn do-bttn--submit",
      class: {
        'do-bttn--submit--loading': _vm.savingRows[row.calendar_id],
        'do-bttn--submit--disabled': !_vm.isChanged(row)
      },
      attrs: {
        "disabled": _vm.savingRows[row.calendar_id] || !_vm.isChanged(row)
      },
      on: {
        "click": function($event) {
          return _vm.submitRow(row.calendar_id)
        }
      }
    }, [_vm._v("\n          Gem\n        ")]) : _vm._e()])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th'), _vm._v(" "), _c('th', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Klokketimer i skoleåret")])]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Brikken")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2526293c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/SubjectFormCalendarHours.vue
// module id = 1810
// module chunks = 1